module.exports = __webpack_public_path__ + "static/media/veinMapping.01569f8f.png";